// Feature flag keys - based on your API response
export const FEATURE_FLAGS = {
    // Transaction Features
    AMBULANCE_BAG_TRANSACTION: 'ambulance-bag-transaction',
    AMBULANCE_BAG_INVENTORY_TRANSACTION: 'ambulance-bag-inventory-transaction',

    // Page Features
    APP_SETTINGS_PAGE: 'app-settings-page',
    DOSE_BAG_PAGE: 'dose-bag-page',
    TRANSACTIONS_PAGE: 'transactions-page',
    CONSUMPTION_LOG_PAGE: 'consumption-log-page',
    CREATE_CONSUMPTION_LOG: 'create-consumption-log',
    INFORMATION_PAGE: 'information-page',
    PROFILE_PAGE: 'profile-page',
    OVERVIEW_PAGE: 'overview-page',
    USER_MANAGEMENT_PAGE: 'user-management-page',
    MEDICATIONS_PAGE: 'medications-page',
    STORAGE_LOCATION_PAGE: 'storageLocation-page',

    // Module Features
    INVENTORY_MANAGEMENT_MODULE: 'inventory-management-module',
} as const;

// Type for feature flag keys
export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
